/* eslint-disable no-undef */
import {
  configureStore,
  Action,
  ThunkAction,
  Middleware,
} from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useSelector } from 'react-redux'

import { isProd } from '../config'
import { forgetAuthUser, logout } from '../pages/Login'
import rootReducer, { RootState } from './slices/reducers'
import { urlSyncMiddleware } from './middleware/urlSyncMiddleware'
import { setSessionExpiredReason } from '../utils/sessionExpiration'

const unauthorizedMiddleware: Middleware<{}, RootState> =
  (store) => (next) => (action) => {
    const result = next(action)

    // Check if the action resulted in a token-related 401 error
    // Only disconnect for "Invalid token" or "No token provided" errors
    const error = (result as any)?.payload?.errors?.[0]
    const isTokenError =
      error?.status === 401 &&
      (error?.message === 'Invalid token' ||
        error?.message === 'No token provided')

    if (isTokenError) {
      // Dispatch the logoutUser action to clear user data
      store.dispatch(logout())
      store.dispatch(forgetAuthUser())
      sessionStorage.clear()

      // Set session expired reason AFTER clear so it persists
      setSessionExpiredReason('expired')
    }

    return result
  }

// const logMiddleware: any = [!isProd && require('redux-logger').default].filter(
//   Boolean
// )

const store = configureStore({
  reducer: rootReducer,
  devTools: !isProd,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(unauthorizedMiddleware, urlSyncMiddleware),
})

export type AppDispatch = typeof store.dispatch

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
